import React from "react";
import { Navigate } from "react-router-dom";

// PrivateRoute component to protect routes
const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated");

  if (isAuthenticated !== "true") {
    // Redirect to login if not authenticated
    return <Navigate to="/admin/login" />;
  }

  // Render the protected children if authenticated
  return children;
};

export default PrivateRoute;
